
export default class SessionCache {

    static user = null;


    static isAuthenticated() {

        if (this.user == null) {
            return null;
        }
        else if (this.user['isAuthenticated']) {
            return true;
        }

        return false;
    }

    static isVerified() {

        return this.user?.isVerified;
    }

    static isPasswordUpdated() {

        return this.user?.passwordUpdated;
    }


    static getName() {
        if (this.user) {
            return this.user?.name;
        }

        return "";
    }

    static getUser() {
        return this.user
    }

    static getUserActions() {
        return this.user?.actions || [];
    }

    static getAllowedModule() {
        return this.user?.accessRights || {};
    }

    static setUser() {
        // let actions = [], accessRights = {}

        // if (obj.types) {
        //     for (let i = 0; i < obj.types.length; i++) {
        //         actions.push(...obj.types[i].actions)
        //     }
        // }

        // actions.forEach(item => {
        //     accessRights[item.name] = item.name
        // })

        // obj.accessRights = accessRights
        // obj.actions = actions
        this.user = {
            "_id" : "6442793baf4e5032ff65eca4",
            "countryCode" : "+91",
            "mobileNumber" : "8105853633",
            "deviceId" : "f3fda70f29c8df5e",
            "name" : "test 121",
            "nickName" : "test 121 n",
            "username" : "test121",
            "gender" : "M",
            // "createdDate" : ISODate("2023-04-21T11:53:31.034Z"),
            "uniqueKey" : "0cd91a49-0c7a-4004-928a-0f9ecb7ea54d",
            "city" : "Abiramam",
            "state" : "Tamil Nadu",
            "country" : "India",
            "timeZone" : "Asia/Kolkata",
            // "countingwellLastUpdateTimestamp" : ISODate("2023-04-24T01:51:38.877Z"),
            "email" : "",
            "deviceInfo" : null,
            "version" : {
                "number" : "3.31",
                "platform" : "android",
                // "updatedDate" : ISODate("2023-04-21T11:53:31.034Z")
            },
            // "countingwellCreatedTimestamp" : ISODate("2023-04-21T11:53:31.042Z"),
            "notificationToken" : "dID8Wgj6SGG6MFajXR99qD:APA91bFG5fn7Hki7FbQuBkQgGi4e3U1kKVd93lIxku4t44OCSbrluuGu2Pq4k-ckORW1ItJ0vDz2dUgV-2ecx2kgIpLqYOOjYXOgXwp8jlS6vQObId05b0r5VcXtk4mw8KO1gdn6b6ca",
            "alternateBoard" : "CBSE",
            "board" : "CBSE",
            "boardId" : "5e16e625e6c888277db41093",
            "class" : "Class 6",
            "doubtsLimit" : {
                "type" : "LIMITED",
                "count" : 5
            },
            "isSubscribed" : true,
            "masterDataId" : "5e71c0afe6a6150727ddc842",
            "school" : {
                "id" : 1,
                "title" : "Other"
            },
            "trail" : {
                "workouts" : [
                    {
                        "id" : "601ce53d18f1e95151e5cc80"
                    },
                    {
                        "id" : "601ce57218f1e95151e5cc84"
                    },
                    {
                        "id" : "5fa109af6b16ca2cbbddcef4"
                    },
                    {
                        "id" : "601ce59018f1e95151e5cc89"
                    }
                ]
            },
            "upgradeLimit" : 0,
            "workflowId" : "5f9412818b2f723e52cc5796",
            "transferKey" : "6442793baf4e5032ff65eca4_1682078014959",
            "moreInfo" : {
                "daysWantsToPractice" : 3,
                "timeForPractice" : "MORNING",
                "dailyGoal" : 20,
                "currentLevelOfMaths" : "ADVANCE",
                "isVideoViewed" : true
            },
            "appTime" : {
                "time" : 68,
                "date" : "Mon_Apr_24_2023"
            },
            "image" : "881155f4-e426-4277-9879-504f7970cda61682301054018.jpg",
            basePath : "https://countingwell-user-profile-pic-dev.s3.ap-south-1.amazonaws.com/"
        };

    };
    
};